<div class="message message-warning">
  <p>
    <% if (provider.licensed_locations.length == 1) { %>
      <%= I18n.visit.callouts.not_licensed_for_location.single_html
            .replace('%{location}', location_during_visit)
            .replace('%{search_url}', licensed_provider_search_url)
            .replace('%{licensed_location}', provider.licensed_locations) %>
    <% } else { %>
      <%= I18n.visit.callouts.not_licensed_for_location.multiple_html
            .replace('%{location}', location_during_visit)
            .replace('%{search_url}', licensed_provider_search_url) %>
      <ul>
        <% _.each(provider.licensed_locations, function(location){ %>
          <li><strong><%= location %></strong></li>
        <% }) %>
      </ul>
    <% } %>
  </p>
</div>
